module.exports = __webpack_public_path__ + "img/bell_4_old.25ccfaee.jpg";